var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplit2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.106 2.925a.727.727 0 011.031 0l2.434 2.433a.727.727 0 010 1.032l-2.434 2.433a.73.73 0 01-1.031-1.031l1.186-1.186h-2.54c-.322 0-.633.127-.86.356L9.083 9.769l2.807 2.808c.229.228.539.356.861.356h2.54l-1.186-1.187a.73.73 0 011.031-1.031l2.434 2.434a.727.727 0 010 1.031l-2.434 2.434a.73.73 0 01-1.031-1.031l1.186-1.187h-2.54c-.709 0-1.39-.283-1.892-.785L7.751 10.5H2.942a.728.728 0 01-.73-.73c0-.404.325-.73.73-.73h4.81L10.86 5.93a2.678 2.678 0 011.892-.785h2.54L14.106 3.96a.727.727 0 010-1.031v-.003z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit2);
export default ForwardRef;